import axios from 'axios';

export default {
  namespaced: true,

  state: {
    employeeRatings: [],
  },

  getters: {
    employeeRatings: (state) => state.employeeRatings,
  },

  mutations: {
    SET_EMPLOYEE_RATINGS(state, data) {
      state.employeeRatings = data;
    },
  },

  actions: {
    async fetchEmployeeRatings({ commit }) {
      const token = localStorage.getItem('token');

      const response = await axios.get(
        'https://apidash.smartpress.kz/api/ratings/employees',
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      commit('SET_EMPLOYEE_RATINGS', response.data);
    },
  },
};